<template>
  <div>
    <h2 class="content-block">Datagrid Loadpanel Practice</h2>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        Put your content here
        <dx-data-grid
          :columns="gridColumns"
          :data-source="gridData"
          :load-panel="loadPanelConfig"
          @initialized="onGridInitialized"
        ></dx-data-grid>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>

<script>
import DataGrid from "devextreme-vue/data-grid";

export default {
  components: {
    DxDataGrid: DataGrid,
  },
  data() {
    return {
      gridColumns: [
        { dataField: "id", caption: "ID" },
        { dataField: "name", caption: "Name" },
        { dataField: "age", caption: "Age" },
      ],
      gridData: null, // Set the initial value of the data source to null
      loadPanelConfig: {
        enabled: true,
        shading: true,
        shadingColor: "#fff",
        showIndicator: true,
        showPane: true,
        text: "Loading...",
      },
    };
  },
  methods: {
    onGridInitialized() {
      // Hide the loading panel when the DataGrid is initialized
      this.loadPanelConfig.enabled = false;

      // Load the data source asynchronously
      this.loadData().then((data) => {
        this.gridData = data;
        setTimeout(() => {
          this.loadPanelConfig.enabled = false;
        }, 500);
      });
    },
    loadData() {
      // Simulate asynchronous data loading
      return new Promise((resolve) => {
        setTimeout(() => {
          const data = [
            { id: 1, name: "John", age: 30 },
            { id: 2, name: "Jane", age: 28 },
            { id: 3, name: "Sam", age: 35 },
          ];
          resolve(data);
        }, 2000);
      });
    },
  },
};
</script>
